<app-device-features-container
  header="{{ '+INSTALLATIONS.INSTALLATION.PANEL.ELECTRIC_HEATER' | translate }}"
  [overlayType]="availableOverlays.ElectricHeater"
  [deviceSelectId]="deviceSelectId"
>
  <!-- heating.configuration.heatingRod.heating -->
  <app-feature-tile
    *ngIf="heatingRodHeating$ | async | ready as feature"
    feature
    data-at-heating-rod-heating
    [label]="'+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.HEATING_CIRCUITS.LABEL' | translate"
    [value]="
      feature.properties?.useApproved?.value
        | booleanSuffix
          : [
              customTranslationsService.STATE.on | translate,
              customTranslationsService.STATE.off | translate
            ]
    "
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  ></app-feature-tile>

  <!-- heating.configuration.heatingRod.dhw -->
  <app-feature-tile
    *ngIf="heatingRodDhw$ | async | ready as feature"
    feature
    data-at-heating-rod-dhw
    [label]="'+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.DHW.LABEL' | translate"
    [value]="
      feature.properties?.useApproved?.value
        | booleanSuffix
          : [
              customTranslationsService.STATE.on | translate,
              customTranslationsService.STATE.off | translate
            ]
    "
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  ></app-feature-tile>

  <!-- heating.heatingRod.status -->
  <app-feature-tile
    *ngIf="heatingRodStatus$ | async | ready as feature"
    feature
    data-at-heating-rod-status
    [label]="'+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.STATUS.LABEL' | translate"
    [value]="getHeatingRodStatusValue(feature) | translate"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  ></app-feature-tile>

  <!-- heating.configuration.dhwHeater -->
  <app-feature-tile
    *ngIf="heatingConfigurationDhwHeater$ | async | ready as feature"
    feature
    data-at-toggle-heating-configuration-dhwHeater
    label="{{
      '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.SEPARATE_HEATING_ROD_DHW.LABEL' | translate
    }}"
    [value]="
      feature.properties?.useApproved?.value
        | booleanSuffix
          : [
              customTranslationsService.STATE.on | translate,
              customTranslationsService.STATE.off | translate
            ]
    "
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  ></app-feature-tile>

  <!-- heating.heatingRod.statistics/starts -->
  <app-feature-tile
    *ngIf="heatingRodStatistics$ | async | ready as feature"
    feature
    data-at-heating-rod-statistics-feature-starts
    label="{{ '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.STATISTICS.STARTS_LABEL' | translate }}"
    value="{{ feature | value2: featurePropertyKey.starts }}"
    [attr.data-feature]="feature.feature + '/starts'"
  >
  </app-feature-tile>
</app-device-features-container>
